$(function () {
  const launchpadBlock = $('.launchpad-block');

  const displayTwo = (card, contentColumns) => {
    $(card).addClass('sm:v2-col-start-2');
    $(contentColumns).removeClass('v2-grid-cols-1');
    $(contentColumns).addClass('v2-grid-cols-2');
  };

  const displayThree = (cards, contentColumns) => {
    cards.each(function (idx, card) {
      $(card).removeClass('v2-pb-full v2-h-0');
      $(card).addClass('sm:v2-pb-full v2-h-40 sm:v2-h-0');
    });

    $(contentColumns).removeClass('v2-grid-cols-1 sm:v2-grid-cols-4');
    $(contentColumns).addClass('sm:v2-grid-cols-3');
  };

  launchpadBlock.each(function (idx, block) {
    const contentColumns = $(block).find('#content-columns');
    const launchpadVariant = $(contentColumns).data('launchpad-variant');
    const cards = $(block).find('.launchpad-card');

    if (launchpadVariant === 'display-two') {
      displayTwo(cards[0], contentColumns);
    }
    if (launchpadVariant === 'display-three') {
      displayThree(cards, contentColumns);
    }
  });
});
